import * as ScreenOrientation from 'expo-screen-orientation'
import { useCallback } from 'react'

export function useScreenOrientation() {
  const lockToPortrait = useCallback(async () => {
    try {
      await ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.PORTRAIT_UP,
      )
    } catch (error) {
      throw new Error('Erro ao travar orientação em retrato: ' + error)
    }
  }, [])

  const lockToLandscape = useCallback(async () => {
    try {
      await ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.LANDSCAPE,
      )
    } catch (error) {
      throw new Error('Erro ao travar orientação em paisagem: ' + error)
    }
  }, [])

  const unlockOrientation = useCallback(async () => {
    try {
      await ScreenOrientation.unlockAsync()
    } catch (error) {
      throw new Error('Erro ao destravar orientação: ' + error)
    }
  }, [])

  const getOrientation = useCallback(async () => {
    try {
      const orientation = await ScreenOrientation.getOrientationAsync()
      return orientation
    } catch (error) {
      throw new Error('Erro ao obter orientação: ' + error)
    }
  }, [])

  return {
    lockToPortrait,
    lockToLandscape,
    unlockOrientation,
    getOrientation,
  }
}
